// actions
import types from './mutation-types';
import api from '../api/index';

const actions = {
  lookProtocol({commit}, flag) {
    commit('LOOK_PROTOCOL', flag);
  },

  // 设置用户问题状态
  setNoQuestion({commit}, flag) {
    commit('NO_QUESTION', flag);
  },

  // 查看协议
  setLoading({commit}, platform) {
    commit('SET_LOADING', platform);
  },

  // 设置全局价格
  setPrice({commit}, data) {
    commit('SET_PRICE', data);
  },

  // 设置banner
  setBanner({commit}, data) {
    commit('SET_BANNERURL', data);
  },

  // 设置在线时间
  setOnlineTime({commit}, data) {
    commit('SET_ONLINETIME', data);
  },

  // 设置是否有新消息
  setNewMessage({commit}, flag) {
    commit('SET_NEWMESSAGE', flag);
  },

  // 更新顶部导航
  updateNav({commit}, value) {
    commit('UPDATE_NAV', value);
  },

  // 更新问题
  updateQuestion({commit}, describe) {
    const count = describe.length;
    let status = '';

    if (count === 0) {
      status = 'disabled';
    } else {
      status = count > 500 ? 'more' : 'normal';
    }

    commit(types.UPDATE_QUESTION, {
      describe,
      count,
      status
    });
  },

  // 更新问题状态
  updateQuestionStatus({commit}, obj) {
    commit(types.UPDATE_QUESTION_STATUS, {
      status: obj.status
    });
  },
  // 设置token
  setToken({commit}, value) {
    commit('SET_TOKEN', value);
  },

  // 登录
  async login() {
    const res = await api.login();
    if (res.data.rtn_code !== '0') {
      return {
        err: res.data.rtn_msg
      };
    }
    return res.data;
  },

  // 我的服务列表
  async getQuestionList({commit}, obj) {
    const res = await api.getQuestions(obj.data);
    if (res.data.rtn_code !== '0') {
      return {
        err: res.data.rtn_msg
      };
    }
    console.log(commit);
    return res.data;
  },

  // 删除问题
  async deleteQuestion({commit}, obj) {
    const res = await api.deleteQuestion(obj);
    if (res.data.rtn_code !== '0') {
      return {
        err: res.data.rtn_msg
      };
    }
    console.log(commit);
    return res.data.data;
  },

  // 获取价格
  async getPrice({commit}, obj) {
    const res = await api.getPrice(obj);
    if (res.data.rtn_code !== '0') {
      return {
        err: res.data.rtn_msg
      };
    }
    console.log(commit);
    return res.data;
  },

  // 获取价格新接口
  async getPriceNew() {
    const res = await api.getPriceNew();
    if (res.data.rtn_code !== '0') {
      return {
        err: res.data.rtn_msg
      };
    }
    return res.data;
  },

  // 获取支付列表
  async getPay({commit}, obj) {
    const res = await api.getPay(obj);
    if (res.data.rtn_code !== '0') {
      return {
        err: res.data.rtn_msg
      };
    }
    console.log(commit);
    return res.data;
  },

  // 唤起原生支付
  async pay({commit}, obj) {
    const res = await api.pay(obj);
    if (res.data.rtn_code !== '0') {
      return {
        err: res.data.rtn_msg
      };
    }
    console.log(commit);
    return res.data;
  },

  // 创建问题
  async createQuestion({commit}, obj) {
    const res = await api.createQuestion(obj);
    if (res.data.rtn_code !== '0') {
      return {
        err: res.data.rtn_msg
      };
    }
    console.log(commit);
    return res.data;
  },

  // 去支付
  async orderPay({commit}, obj) {
    const res = await api.orderPay(obj);
    if (res.data.rtn_code !== '0') {
      return {
        err: res.data.rtn_msg
      };
    }
    console.log(commit);
    return res.data;
  },

  // 医生详情
  async getDoctorDetail({commit}, obj) {
    const res = await api.getDoctor(obj);
    if (res.data.rtn_code !== '0') {
      return {
        err: res.data.rtn_msg
      };
    }
    commit(types.DOCTOR_DETAIL, res.data.data);
    return res.data.data;
  },

  // 评价医生
  async rate({commit}, obj) {
    const res = await api.rate(obj);
    if (res.data.rtn_code !== '0') {
      return {
        err: res.data.rtn_msg
      };
    }
    commit(types.IS_RATE, true);
    return res.data;
  },

  // 获取问题详情
  async getQuestionDetail({commit}, obj) {
    const res = await api.getQuestionDetail(obj);
    console.log(commit);
    return res.data;
  },

  // 上传图片
  async uploadImage({commit}, obj) {
    commit(types.SET_LOADING, true);
    const res = await api.uploadImage(obj);
    commit(types.SET_LOADING, false);
    return res.data;
  },

  // base64 上传图片
  async uploadImageBase64({commit}, obj) {
    commit(types.SET_LOADING, true);
    const res = await api.uploadBase64(obj);
    commit(types.SET_LOADING, false);
    return res.data;
  },

  // 通过表单形式上传图片
  async uploadImageByForm({commit}, obj) {
    commit(types.SET_LOADING, true);
    setTimeout(() => {
      commit(types.SET_LOADING, false);
    }, 30000);
    const res = await api.uploadImageByForm(obj);
    commit(types.SET_LOADING, false);
    return res.data;
  },

  // 轮询医生反馈信息
  async pollingLatestMsg({commit}, obj) {
    const res = await api.pollingLatestMsg(obj);
    console.log(commit);
    return res.data.data;
  },

  // 用户追问（发送消息）
  async sendAskedMsg({commit}, obj) {
    const res = await api.sendAskedMsg(obj);
    console.log(commit);
    return res.data;
  },

  // 获取历史消息
  async getHistoryMsg({commit}, obj) {
    const res = await api.getHistoryMsg(obj);
    console.log(commit);
    return res.data.data;
  },

  // 获取最新消息
  async getMsgUnread({commit}, obj) {
    const res = await api.getMsgUnread(obj);
    console.log(commit);
    return res.data.data;
  },

  // 获取最新消息
  async readAudioMsg({commit}, obj) {
    const res = await api.readAudioMsg(obj);
    console.log(commit);
    return res.data.data;
  },

  // h5端获取调用支付宝和微信支付所需要的参数
  async getH5ReqMsg({commit}, obj) {
    const res = await api.getH5ReqMsg(obj);
    if (res.data.rtn_code !== '0') {
      return {
        err: res.data.rtn_msg
      };
    }
    console.log(commit);
    return res.data;
  },

  // h5端获取调用支付宝和微信支付所需要的参数
  async getWechatReqMsg({commit}, obj) {
    const res = await api.getWechatReqMsg(obj);
    if (res.data.rtn_code !== '0') {
      return {
        err: res.data.rtn_msg
      };
    }
    console.log(commit);
    return res.data;
  },

  // 微信授权
  async wxAuth({commit}, obj) {
    // commit(types.SET_LOADING, true);
    const res = await api.wxAuth(obj);
    // commit(types.SET_LOADING, false);
    console.log(commit);
    return res.data;
  },

  // 获取后台配置的静态数据
  async getConstantData({commit}, obj) {
    const res = await api.getConstantData(obj);
    if (res.data.rtn_code === '0') {
      const constantData = res.data.data;
      constantData.forEach((item) => {
        if (item.type === 9) {
          const vipOpenText = item.value[0].letter;
          commit(types.GET_CONSTANT_DATA, vipOpenText);
        }
      });
    }
    return res.data;
  },

  // 查询会员信息
  async getUserMemberInfo({commit}, obj) {
    const res = await api.getUserMemberInfo(obj);
    if (res.data.rtn_code === '0') {
      commit(types.MEMBER_STATE, res.data.data.memberState);
    }
    return res.data;
  },
  // 设置vip产品信息
  setGoodsVipInfo({commit}, data) {
    commit('GOODS_VIP_INFO', data);
  }
};

export default actions;

// 支付宝回调表单
export function submitForm(action, params) {
  const formEl = document.querySelector('form[name=to-pay-form]');
  if (formEl) {
    const parentNode = formEl.parentNode;
    parentNode.removeChild(formEl);
  }
  const aliForm = document.createElement('form');
  aliForm.name = 'to-pay-form';
  aliForm.action = action;
  aliForm.method = 'get';
  aliForm.target = '_self';
  document.body.appendChild(aliForm);
  // params.req_data = params.req_data.replace(/</g, '&#60;').replace(/>/g, '&#62;');
  Object.keys(params).forEach((key) => {
    const aliInput = document.createElement('input');
    aliInput.type = 'hidden';
    aliInput.name = key;
    aliInput.value = params[key];
    aliForm.appendChild(aliInput);
  });
  aliForm.style.display = 'none';
  aliForm.submit();
}




// WEBPACK FOOTER //
// ./src/stores/actions.js